module.exports = __webpack_public_path__ + "media/images/p3-7b47c54d6fdb0e9770447fc761fbf843.jpg";